import { StyledPropsTheme } from '../../types';
import parent from './standard';

export default Object.assign({}, parent, {
	COLOR_PRIMARY: '#FFA20A', // 标准色
	COLOR_PRIMARY_LIGHT_O75: 'rgba(255, 162, 10, 0.75)', // 标准色75%透明
	COLOR_PRIMARY_LIGHT_010: 'rgba(255, 162, 10, 0.1)',
	COLOR_PRIMARY_LIGHT: '#ffb53d', // 标准色淡10%
	INPUT_FOCUS_BORDER_COLOR: 'rgba(255, 162, 10, 0.8)', // 输入框获取焦点后边框色
	TOGGLE_TRUE_BORDER_COLOR: '#FFA20A',
	TOGGLE_TRUE_BACKGROUND_COLOR: '#FFA20A',
}) as StyledPropsTheme;
